import { initializeApp } from "firebase/app";
import {browserSessionPersistence, getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyCeH4yKTPYDJzzjWBF54W_zz3RHPVnoZkk",
  authDomain: "miqrapp-6919f.firebaseapp.com",
  projectId: "miqrapp-6919f",
  storageBucket: "miqrapp-6919f.appspot.com",
  messagingSenderId: "245553561153",
  appId: "1:245553561153:web:540467e5d76532ac7190c0"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).then(() =>{})
.catch((error) => {
  console.error(error)
})

const provider = new GoogleAuthProvider();

const db = getFirestore(app);
const storage = getStorage(app);

export {app, auth, provider, db, storage}
